import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faGear,
    faPlus,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
    useNavigateWithinOrg,
    useNavigateWithinProject,
} from '../utils/navigation';
import VersionSwitcher from './VersionSwitcher';
import LabelDetailControls from './LabelDetailControls';
import PackCopyDetailControls from './PackCopyDetailControls';
import ActionButton from './ActionButton';
import AddModal from './AddModal';

interface ProjectDetailsTitleBarProps {
    projectName: string;
    detailView?: 'pack copy' | 'label';
}

const ProjectDetailsTitleBar: React.FC<ProjectDetailsTitleBarProps> = ({
    projectName,
    detailView,
}) => {
    const [showAddModal, setShowAddModal] = useState(false);
    const modalButtonRef = useRef<HTMLButtonElement>(null);

    const navigateWithinOrg = useNavigateWithinOrg();
    const navigateWithinProject = useNavigateWithinProject();

    const handleBackButtonClick = () => {
        if (detailView === 'pack copy') {
            navigateWithinProject('/pack-copies');
        }
        if (detailView === 'label') {
            navigateWithinProject('/labels');
        }
        if (!detailView) {
            navigateWithinOrg('/projects');
        }
    };

    return (
        <div className="title-bar">
            <div className="title-back-container">
                <button className="back-button" onClick={handleBackButtonClick}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>

                <h2>{projectName}</h2>
                {detailView && <VersionSwitcher detailView={detailView} />}
            </div>
            <div className="right-container">
                <div style={{ position: 'relative' }}>
                    <ActionButton
                        text="Add"
                        onClick={() => setShowAddModal(!showAddModal)}
                        icon={faPlus}
                        iconPosition="left"
                        fontSize="large"
                        buttonRef={modalButtonRef}
                    />
                    {showAddModal && (
                        <AddModal
                            closeModal={() => setShowAddModal(false)}
                            modalButtonRef={modalButtonRef}
                        />
                    )}
                </div>

                {!detailView && (
                    <div className="controls">
                        <button className="controls-button">
                            <FontAwesomeIcon icon={faGear} />
                        </button>
                    </div>
                )}

                {detailView === 'label' && <LabelDetailControls />}
                {/* {detailView === 'pack copy' && <PackCopyDetailControls />} */}
            </div>
        </div>
    );
};

export default ProjectDetailsTitleBar;
